<template>
  <div class="topOther">
    <div class="topOther__link">
      <div><a @click="gotoAbout">RENGAについて</a></div>
    </div>
    <div class="topOther__link">
      <a :href="archives" target="_blank" class="externalLink">過去のRENGA</a>
    </div>
  </div>
</template>

<script>
import {setPage} from "../../../util/StoreUtil";
import {archives} from "../../../data/Links";

export default {
  name: "TopOther",
  computed: {
    archives() {
      return archives;
    }
  },
  methods: {
    gotoAbout() {
      setPage("about");
    }
  }
};
</script>

<style scoped lang="sass">
@import "../../../sass/common"
.topOther
  text-align: center
  //font-size: 19px
  @include vw(19)

  padding: 60px 0
  .topOther__link
    margin-bottom: 2.1em
    &:last-child
      margin-bottom: 0
  a
    color: white
    border-bottom: 2px solid #ff6464
    text-decoration: none
    display: inline-block
    position: relative
    &.externalLink
      &:after
        content: ""
        background: url("../../../assets/ui/link-large.png") no-repeat 0 0
        width: 12px
        height: 12px
        background-size: contain
        display: block

        position: absolute
        top: 10px
        right: -18px

</style>
